import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Code } from '#app/components/typography/code.tsx'
import { P } from '#app/components/typography/p.tsx'
import { Span } from '#app/components/typography/span.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Span',
}

const component: componentProps = {
	name: 'Span',
	shortName: 'Span',
	fileName: 'span',
	category: 'typography',
	description: ['Span component.'],
	features: ['Drop-in replacement for the native <span> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<p className="font-serif text-xl">
	If I have a component with custom typographical properties and <Span>I need to opt back into my design system's typography</Span>, I can use the <Code>{'<Span />'}</Code> component.
</p>`,
	styling: `.span {
	@apply font-sans;
}`,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const SpanRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<p className="font-serif text-xl">
				If I have a component with custom typographical properties and <Span>I need to opt back into my design system's typography</Span>, I can use the <Code>{'<Span />'}</Code>{' '}
				component.
			</p>
			<Features features={features} />
			<Parts parts={parts} />
			<P className="mt-4">The tracking's default value depends on the size prop and is controlled through CSS variables: check out the styling section.</P>
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default SpanRoute
